import { Form } from '@juvare/common-form-ui/Form';
import React from 'react';
export const BadgeCreateTemplateSettingsForm = ({ state, badgeTemplate, setState, formRef, }) => (React.createElement(Form, { ref: formRef, hideFormControls: true, data: state, config: badgeTemplate.data.form, onChanged: (changed, submit) => {
        if (changed) {
            // ignore error to avoid error popup
            submit().catch(() => { });
        }
    }, onSubmit: (stateNext) => {
        return Promise.resolve(stateNext);
    }, onSubmitSuccess: (stateNext) => {
        setState(Object.assign({}, stateNext));
    } }));
